import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { useColors } from "../../hooks/colors/useColors";
import { Container } from "../../components/UI/container/Container";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { isPhone } from "../../constants/env";
import { MyHead } from "../../components/pages/MyHead";
import { Fragment } from "react";
import { Footer } from "../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function ContactPage() {
  const { colors } = useColors();
  const { t } = useTranslation("common");

  return (
    <Fragment>
      <MyHead title={t("terms")} description={t("terms")} />
      <PageHeader>
        <MyH1
          size={isPhone ? "2.5rem" : "3rem"}
          color={colors.white}
          className="text-center"
        >
          {t("terms")}
        </MyH1>
      </PageHeader>
      <div>
        <Container noHeight>
          <div
            // @ts-ignore
            dangerouslySetInnerHTML={{ __html: t("terms-content") }}
          />
        </Container>
      </div>
      <Footer isVisible />
    </Fragment>
  );
}

export default ContactPage;
